var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4821_9516)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31982 9.95703L4.65316 9.95757L4.65113 14.9576L3.31779 14.957L3.31982 9.95703ZM11.6532 9.96042L12.9865 9.96096L12.9845 14.961L11.6511 14.9604L11.6532 9.96042ZM5.98649 9.95811L5.31982 9.95784L5.31779 14.9578L5.98446 14.9581L5.98649 9.95811ZM7.65316 9.95879L8.98649 9.95933L8.98446 14.9593L7.65113 14.9588L7.65316 9.95879ZM10.9865 9.96015L11.3198 9.96028L11.3178 14.9603L10.9845 14.9601L10.9865 9.96015ZM10.3198 9.95987L9.65316 9.9596L9.65113 14.9596L10.3178 14.9599L10.3198 9.95987ZM7.31982 9.95866L6.65316 9.95839L6.65113 14.9584L7.31779 14.9587L7.31982 9.95866ZM13.3198 9.96109L13.9865 9.96136L13.9845 14.9614L13.3178 14.9611L13.3198 9.96109ZM14.6532 9.96163L14.3198 9.9615L14.3178 14.9615L14.6511 14.9616L14.6532 9.96163Z",
    fill: "#42495E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.32275 2.95703L4.65609 2.95757L4.65406 7.95757L3.32072 7.95703L3.32275 2.95703ZM11.6561 2.96042L12.9894 2.96096L12.9874 7.96096L11.6541 7.96042L11.6561 2.96042ZM5.98942 2.95811L5.32275 2.95784L5.32072 7.95784L5.98739 7.95811L5.98942 2.95811ZM7.65609 2.95879L8.98942 2.95933L8.98739 7.95933L7.65406 7.95879L7.65609 2.95879ZM10.9894 2.96015L11.3228 2.96028L11.3207 7.96028L10.9874 7.96014L10.9894 2.96015ZM10.3228 2.95987L9.65609 2.9596L9.65406 7.9596L10.3207 7.95987L10.3228 2.95987ZM7.32275 2.95866L6.65609 2.95839L6.65406 7.95838L7.32072 7.95866L7.32275 2.95866ZM13.3228 2.96109L13.9894 2.96136L13.9874 7.96136L13.3207 7.96109L13.3228 2.96109ZM14.6561 2.96163L14.3228 2.9615L14.3207 7.9615L14.6541 7.96163L14.6561 2.96163Z",
    fill: "#42495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.986816 8.62305L16.9868 8.62955L16.9865 9.29621L0.986546 9.28971L0.986816 8.62305Z",
    fill: "#42495E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.6567 1.62792L13.6565 2.29459L15.6565 2.2954L15.6557 4.2954L16.3223 4.29567L16.3234 1.629L13.6567 1.62792Z",
    fill: "#004870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3185 13.629L15.6519 13.6287L15.651 15.6287L13.651 15.6279L13.6508 16.2946L16.3174 16.2957L16.3185 13.629Z",
    fill: "#004870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.31745 16.2908L4.31772 15.6241L2.31772 15.6233L2.31853 13.6233L1.65186 13.623L1.65078 16.2897L4.31745 16.2908Z",
    fill: "#004870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65566 4.28971L2.32232 4.28998L2.32313 2.28998L4.32313 2.2908L4.3234 1.62413L1.65674 1.62305L1.65566 4.28971Z",
    fill: "#004870"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4821_9516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.990234 0.957031) rotate(0.0232726)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeIcon);
export default __webpack_public_path__ + "static/media/QRCodeIcon.02916109.svg";
export { ForwardRef as ReactComponent };